<div class="row">
  <importer-simple-table
    class="mat-elevation-z4"
    [header]="tableHeader"
    [externalDataInput$]="fileTypeService.fileTypeSubject$"
    [hidePagination]="true"
    [loading]="loading()">
    <ng-template
      #columns
      let-item>
      @if (item) {
        <div class="content-column">
          @if (item) {
            <div class="row">
              <div class="edit-menu-items mat-elevation-z4">
                <i
                  class="edit-button material-icons"
                  (click)="openEditFileTypePopup(item)">
                  edit
                </i>
              </div>
              <div class="edit-menu-items mat-elevation-z4">
                <i
                  class="edit-button material-icons"
                  (click)="openDeleteFileTypePopup(item)">
                  delete_forever
                </i>
              </div>
            </div>
          }
        </div>
      }
      <div class="content-column">
        @if (item) {
          <div class="row">
            <p>
              {{ item.displayedName }}
            </p>
          </div>
        }
      </div>

      <div class="content-column">
        <div class="ps-wrapper">
          @if (item) {
            <div>
              <p class="ps ps--finalized">{{ item.fileFormat }}</p>
            </div>
          }
        </div>
      </div>
      <div class="content-column ps-wrapper">
        @if (item) {
          <div class="row">
            <p>{{ item.exportAttributes.length }}</p>
            <i
              class="edit-button material-icons"
              (click)="openEditAttributesPopup(item)">
              edit
            </i>
          </div>
        }
      </div>
      <div class="content-column">
        <div class="ps-wrapper">
          @if (item) {
            <div>
              <p class="ps ps--finalized">{{ getThreshold(item) ?? 'none' }}</p>
            </div>
          }
        </div>
      </div>
      <div class="content-column">
        <div class="ps-wrapper">
          @if (item) {
            <div>
              <p class="ps ps--finalized">{{ item.retentionTime || 'none' }}</p>
            </div>
          }
        </div>
      </div>
      <div class="content-column">
        <div class="ps-wrapper">
          @if (item) {
            <div>
              @if (item.emailAddress && item.emailAddress.length > 0) {
                <i class="email-button material-icons">alternate_email</i>
              }
              @if (!item.emailAddress || !item.emailAddress.length) {
                <p class="ps ps--finalized">none</p>
              }
            </div>
          }
        </div>
      </div>
      <div class="content-column">
        @if (item) {
          <div class="ps-wrapper">
            <coin-v2-button
              [type]="'primary'"
              [icon]="'edit'"
              [iconPos]="'right'"
              [text]="'Edit'"
              (click)="updateCustomValidation(item)"></coin-v2-button>
          </div>
        }
      </div>
    </ng-template>
    <ng-template #noData>
      <p>no data</p>
    </ng-template>
  </importer-simple-table>
</div>
